import type {EditableTableSortEntry} from '../../ui/EditableTable/EditableTable';
import type Task from '../../entities/task';

/**
 * Sort configuration for the Support → Bad Tasks table.
 *
 * Extracted into its own module with type-only imports (no runtime dependencies)
 * so the OWA-407 regression test in EditableTable.test.tsx can exercise the EXACT
 * production sort config without rendering the Redux-connected BadTasks page.
 *
 * OWA-407: `dueDate` and `completionDate` hold raw `Date` values. They MUST stay
 * `type: 'date'`. An untyped (or `'string'`-typed) date sortProp routes to the
 * lexicographic `stringSort`, which calls `Date.prototype.localeCompare` — which is
 * `undefined` on a `Date` — and throws the moment two dated rows are compared.
 */
export const BAD_TASKS_SORT_PROPS: EditableTableSortEntry<Task>[] = [
    {label: 'id'},
    {label: 'title'},
    {label: 'invoiceNotes'},
    {label: 'dueDate', type: 'date'},
    {label: 'completionDate', type: 'date'},
    {label: 'assignedTo'},
    {label: 'reasonCode'},
    {label: 'reasonMessage'},
];
